/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import MainBody from "../../components/MainBody/MainBody";
import sortCaret from "../../components/SortCaret";
import { useTrust } from "../../lib/context/TrustContext";

// Here id => VenderId
const ExpandJob = ({ id = "", expandList = false }) => {
  const [loading, setLoading] = useState(false);
  const [expandedData, setExpandedData] = useState([]);
  const { trustId } = useTrust();

  // *API Call for Fetching ABA Transactions List - Start
  const fetchTask = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.GET_TASKS}?ts_job_id=${id}&page=${1}&limit=-1&trust_id=${
          trustId ? trustId : ""
        }`
      );
      const expand = data?.data?.data;
      setExpandedData(expand);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setExpandedData();
    }
  }, [id, trustId]);

  useEffect(() => {
    fetchTask();
  }, [fetchTask]);
  // *API Call for Fetching ABA Transactions List - End

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  // *API Call for Geting Assets - End

  // *Assets Table Row and Column Generation, Filtering and Sorting of Record - Start
  const expandGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandedData[i]?.id,
        title: expandedData[i]?.title ? expandedData[i]?.title : "-",
        code: expandedData[i]?.code ? expandedData[i]?.code : "-",
        description: expandedData[i]?.description
          ? expandedData[i]?.description
          : "-",
      });
    }
    return items;
  };

  const expandTableData = expandGenerator(expandedData?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "title",
      text: "Title",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },
  ];

  // *Assets Table Row and Column Generation, Filtering and Sorting of Record - End

  return (
    <>
      <MainBody
        search={false}
        expandList={expandList}
        loading={loading}
        actionContent={false}
        innerBody={true}
      >
        <div className="custom-table">
          <div className={"table-body-class"}>
            <BootstrapTable
              keyField="key"
              remote
              data={expandTableData}
              columns={columns}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
        </div>
      </MainBody>
    </>
  );
};
export default ExpandJob;
